import moment from "moment";
import "moment-business-days"; // augments moment.fn with businessAdd (ships its own types)
import INewServiceLevel from "@models/INewServiceLevel";
import LeadTimeTypeEnum from "@models/LeadTimeTypeEnum";

/**
 * Projected ship date for a service level if an order were placed on `from` (defaults to now).
 *
 * `days` lead times count BUSINESS days (weekends skipped) to match the "In Business Days"
 * label on the service-level create form; `weeks`/`months` add calendar time.
 */
export const getServiceLevelShipDate = (level: INewServiceLevel, from = moment()): moment.Moment => {
    const m = from.clone();

    switch (level.lead_time_type) {
        case LeadTimeTypeEnum.WEEKS:
            return m.add(level.lead_time, "weeks");
        case LeadTimeTypeEnum.MONTHS:
            return m.add(level.lead_time, "months");
        case LeadTimeTypeEnum.DAYS:
        default:
            return m.businessAdd(level.lead_time);
    }
};
